import { gql } from "@apollo/client";

export default gql`
  mutation setEmployerJobReminder($data: JobInput!) {
    setEmployerJobReminder(data: $data){
      id
    }
  }
`;
